import React, { Component } from "react";
import Predefine_Polo_HalfS_Cricket from "../components/Predefine_Polo_HalfS_Cricket/Predefine_Polo_HalfS_Cricket";

export class Predefine_Polo_HalfS_CricketPage extends Component {
  render() {
    return <Predefine_Polo_HalfS_Cricket />;
  }
}

export default Predefine_Polo_HalfS_CricketPage;
